module.exports = __webpack_public_path__ + "media/Yarn3.cdeeece9.mp4";